var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center--bottom"},[_c('h2',{staticClass:"f-tac"},[_vm._v("正常运行设备")]),_c('dv-scroll-board',{ref:"scrollBoard",staticClass:"center--bottom_tabel",attrs:{"config":_vm.dataConfig}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }